import React, { SetStateAction } from 'react'
import classes from './TelegramLoginForm.module.sass'
import { Link } from 'react-router-dom'
import {
  PERSONAL_DATA_AGREEMENT_ROUTE,
  PRIVACY_POLICY_ROUTE,
  USER_AGREEMENT_ROUTE,
} from '../../../common/utils/constants'
import { CommonModalPayload, LoginStage } from '../../../common/types/interfaces'

import { Loader } from '../../../common/components/loader/Loader'
import tg_logo from '../../../assets/images/icons/tg_logo.webp'
import login from '../../../assets/images/icons/login.svg'
import { Button } from '../../../common/components/button/Button'
import { Toggle } from '../../../common/components/toggle/Toggle'
import { useTelegramLoginForm } from './hooks/useTelegramLoginForm'

const checkBoxTitle = (
  <>
    {`Согласие с `}
    {
      <Link target="blank" to={PRIVACY_POLICY_ROUTE}>
        {`политикой в отношении обработки персональных данных`}
      </Link>
    }
    {`, `}
    {
      <Link target="blank" to={PERSONAL_DATA_AGREEMENT_ROUTE}>
        соглашением об обработке персональных данных
      </Link>
    }
    {` и `}
    {
      <Link target="blank" to={USER_AGREEMENT_ROUTE}>
        пользовательским соглашением
      </Link>
    }
  </>
)

type Props = {
  setModalActive:
    | React.Dispatch<SetStateAction<boolean>>
    | ((state: boolean) => {
        payload: CommonModalPayload
        type: 'common-modal/setCommonModalState'
      })
  onAttachEmail: () => void
}

export const TelegramLoginForm = ({ setModalActive, onAttachEmail }: Props) => {
  const { stage, loading, message, isLogin, toggleLegality, legalityChecked, botLoginAction } =
    useTelegramLoginForm(setModalActive, onAttachEmail)

  return (
    <div className={classes.Container} onClick={(e) => e.stopPropagation()}>
      {loading ? (
        <>
          <Loader />
          <div className={classes.Description}>{message}</div>
        </>
      ) : (
        <>
          <div className={classes.Title}>{isLogin ? 'Авторизация' : 'Регистрация'}</div>

          <div className={classes.LoginButtons}>
            <img src={login} className={classes.TelegramLogoInactive} alt="Вход через телеграм" />
            <img className={classes.TelegramLogoInactive} src={tg_logo} alt="Вход через телеграм" />
          </div>

          {stage === LoginStage.botLink ? (
            <div className={classes.Description}>
              Создание аккаунта и авторизация на базе Telegram, после нажатия кнопки, вы будете
              перенаправлены в наш бот и следуйте инструкциям. После авторизации вы будете
              перенаправлены в logid, не удаляйте наш бот. Мы будем информировать вас через него о
              важных для вас событиях в logid. Необходим аккаунт Telegram
            </div>
          ) : (
            <div className={classes.Description}>{message}</div>
          )}
          {!isLogin && stage === LoginStage.botLoginProcess ? (
            <>
              <div className={classes.ToggleContainer}>
                <Toggle id={'legality'} onChange={toggleLegality} checked={legalityChecked} />
                <div>{checkBoxTitle}</div>
              </div>
              <Button
                text="Зарегистрироваться"
                onClick={botLoginAction}
                disabled={!isLogin && !legalityChecked}
              />
            </>
          ) : stage === LoginStage.botLink || stage === LoginStage.botLoginError ? (
            <Button href="https://t.me/logid_bot" text="Перейти в бот" />
          ) : (
            <></>
          )}
        </>
      )}
    </div>
  )
}
